import React from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/react/daygrid'
import timeGridPlugin from '@fullcalendar/react/timegrid'
import interactionPlugin from '@fullcalendar/react/interaction'
import classicTheme from '@fullcalendar/react/themes/classic'
import './myCalendar.css'


export default class MyCalendar extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      eventList: props.eventList,
      displayDialog: props.displayDialog,
      user: props.user,
      filterSelected: props.filterSelected
    };
  }

  // need to update to new hook
  componentWillReceiveProps(nextProps) {
    this.setState({ eventList: nextProps.eventList, displayDialog: nextProps.displayDialog, user: nextProps.user, filterSelected: nextProps.filterSelected });  
  }

 
    
 

  render() {
        

  

    return (

      <div className='calendarDiv'>
      <a name='calendarTarget'></a>
      <FullCalendar
        plugins={[ dayGridPlugin, timeGridPlugin, interactionPlugin, classicTheme ]}

        // Changes the Hours Div when the date on the calendar is changed
        datesSet={(dateInfo) => {
          this.props.getTimeAndDate(dateInfo.start.toLocaleDateString(), dateInfo.end.toLocaleDateString(), dateInfo.startStr, dateInfo.endStr);
        }}
        headerToolbar={{ left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek,timeGridDay' }}
        views={{
          dayGridMonth: { // name of view
            titleFormat: { year: 'numeric', month: '2-digit', day: '2-digit' }
            // other view-specific options here
          },
          timeGridWeek: {
            titleFormat: { year: 'numeric', month: 'short', day: 'numeric' }
          },
          timeGridDay:{
            titleFormat: {year: 'numeric', month: 'short', day: 'numeric'}
          }
        }}

        firstDay={5}
        eventTimeFormat={{ // like '14:30:00'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: true
        }}
        eventContent={renderEventContent}
        initialView="timeGridWeek"
        displayEventEnd={true}
        events={this.state.eventList}
        eventClick={this.handleEventClick}
        eventColor={'#7460f3'}
        slotMinHeight={30}
        height="auto"
        
      
      />
      </div>
      
    )
  }


  handleEventClick = (arg) => {
    this.props.setEventClickedObject(arg);
    this.props.setDisplayDialog(true);
  }

}





function renderEventContent(eventInfo) {

    return (
      
      <>
        <div id="dayAndDateLabel">{String(eventInfo.event.start).split("202")[0]}</div>
        <div id="timeEventLabel">{eventInfo.timeText}{eventInfo.event.extendedProps.editedStartTime != "" && "*"}{eventInfo.event.extendedProps.repeatingShift && " ↻"}</div>
        
        <div className="clientAndCaretakerDiv">
        <div id="clientCaretakerEventLabel"><div id="clientLabelRender"><i>{eventInfo.event.extendedProps.client}</i></div>
          <div id="dashP">{" - "}</div><div id="caretakerLabelRender"><b>{eventInfo.event.extendedProps.caretaker}</b></div></div>
        </div>
        <div className="descriptionDiv">
          <div>{eventInfo.event.extendedProps.comments}</div>
        </div>
        
      </>
    )
  }

